<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <div class="row">
            <div class="col-md-10">
                <div class="card flex-fill">
                    <b-tabs small card>
                        <b-tab active class="p-2">
                            <template #title>
                                <b-icon icon="calendar-date" variant="primary"></b-icon>
                                <span class="ms-2">Filtrar por fecha de generación</span>
                            </template>
                            <DateFilter @filter="fetchDocuments" :initialRange="dateRange" :hideClear="true">
                            </DateFilter>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>

            <div class="col-md-2 ps-0 d-flex">
                <div class="align-items-center flex-grow-1">
                    <div class="h-100 d-flex flex-column justify-content-center">
                        <PrintWindow class="w-100 mb-2" tooltip="Imprimir tabla" title="Reporte de Documentos">
                            <CompanyInformationCard :title="reportTitle" class="mb-3"></CompanyInformationCard>
                            <DocumentReportTable :items="documents" />
                        </PrintWindow>
                        <DocumentReportExcel class="mt-2" :items="documents" />

                    </div>
                </div>
            </div>
        </div>

        <DocumentReportTable class="m-3" :items="documents"></DocumentReportTable>
    </div>
</template>

<script>
import DateFilter from '@/components/shared/Filters/Date-filter.vue'
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import DocumentReportTable from './DocumentReport/Document-report-table.vue'
import PrintWindow from '@/components/shared/Print-window.vue'
import { mapActions } from 'vuex'
import { addDays, formatDateInput } from '@/plugins/complianceScripts/index.js'
import CompanyInformationCard from '../shared/Company-information-card.vue'
import DocumentReportExcel from './DocumentReport/Document-report-excel.vue'

export default {
    name: 'DocumentReport',

    components: {
        DateFilter,
        AlertDismiss,
        DocumentReportTable,
        PrintWindow,
        CompanyInformationCard,
        DocumentReportExcel
    },

    data() {
        const today = new Date()
        const sevenDaysAgo = addDays(today, -7)

        return {
            dateRange: {
                startDate: formatDateInput(sevenDaysAgo) + 'T00:00:00.000Z',
                endDate: formatDateInput(today) + 'T23:59:59.999Z'
            },
            documents: null
        }
    },

    async mounted() {
        await this.fetchDocuments(this.dateRange)
    },

    computed: {
        reportTitle() {
            return `Documentos subidos a compliance: (${this.formatDateOnly(this.dateRange.startDate)} - ${this.formatDateOnly(this.dateRange.endDate)})`;
        }
    },

    methods: {
        ...mapActions(['allDocumentByDate', 'getAllVisitorForDocumentId', 'getAllNonVisitorForDocumentId']),

        formatDateOnly(date) {
            if (!date) return '';
            const fechaHora = new Date(date);
            return fechaHora.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        },

        async fetchDocuments(range) {
            this.dateRange = range;

            let result = await this.allDocumentByDate({
                initDate: range.startDate,
                finalDate: range.endDate
            });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message, "danger");
                return;
            }

            let documentsPromise = result.data.map(async document => {
                // Fetch visitors
                let visitorResult = await this.getAllVisitorForDocumentId({ documentId: document.id });
                if (!visitorResult.isError) {
                    document.visitors = visitorResult.data;
                } else {
                    this.$refs.alertDismiss.showAlert(`Error descargando vistas ${document.id}: ${visitorResult.message}`, "danger");
                }
                
                // Fetch non-visitors
                let nonVisitorResult = await this.getAllNonVisitorForDocumentId({ documentId: document.id });
                if (!nonVisitorResult.isError) {
                    document.nonVisitors = nonVisitorResult.data;
                } else {
                    this.$refs.alertDismiss.showAlert(`Error descargando correos no vistos ${document.id}: ${nonVisitorResult.message}`, "danger");
                }
                
                return document;
            });

            this.documents = await Promise.all(documentsPromise);
        }
    }
}
</script>

<style></style>